import { List } from 'immutable';
import { ModerateSession as ModerateSessionPresenter } from './presenter';
import { connect, getQuizSession, getQuizSessionEvents, getSessionItems, openModal, addSuccess, getQuizSessionById, sessionStore } from '@instructure/quiz-core';
import { QUIZ_SESSION_EVENTS_FETCH_CALL, QUIZ_SESSION_FETCH_CALL, SESSION_ITEMS_FETCH_CALL } from '@instructure/quiz-common';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var logToken = sessionStore.get('quiz_sessions.log_token');
  var quizSession = getQuizSessionById(state, quizSessionId);
  var quizSessionEvents = quizSession && quizSession.getEvents() || List();
  var sessionItemsLoaded = state.get('sessionItems').some(function (value, key) {
    return key.includes("".concat(quizSessionId, "_"));
  });
  var isFetching = [state.getIn(['calls', QUIZ_SESSION_FETCH_CALL, 'requestStatus']), state.getIn(['calls', QUIZ_SESSION_EVENTS_FETCH_CALL, 'requestStatus']), state.getIn(['calls', SESSION_ITEMS_FETCH_CALL, 'requestStatus'])].includes('calling') || !sessionItemsLoaded;
  return {
    isFetching: isFetching,
    quizSession: quizSession,
    quizSessionEvents: quizSessionEvents,
    sessionItemsLoaded: sessionItemsLoaded,
    logToken: logToken
  };
}
export var mapDispatchToProps = {
  addSuccess: addSuccess,
  getQuizSession: getQuizSession,
  getQuizSessionEvents: getQuizSessionEvents,
  getSessionItems: getSessionItems,
  openModal: openModal
};
export var ModerateSession = connect(mapStateToProps, mapDispatchToProps)(ModerateSessionPresenter);
export default ModerateSession;